import ThankYouModal from "./ThankYouModal";

class VendorPartnershipModal {
    wrap = null;
    modal = null;
    closeButton = null;
    backdrop = null;
    contactFormId = null;
    thankYouModal = null;

    constructor() {
        this.init();
    }

    init() {
        this.#fetchElements();
    }

    show() {
        if ( this.modal && this.backdrop ) {
            this.modal.classList.add('icore-eventsbyrsquare-popup--active');
            this.backdrop.classList.add('backdrop--isActive');
            document.body.classList.add('icore-eventsbyrsquare-popup--is-active');
            if ( window.$iCore.lenis ) {
                window.$iCore.actions.destroyLenis();
            }
        }
    }

    hide() {
        if ( this.modal && this.backdrop ) {
            this.modal.classList.remove('icore-eventsbyrsquare-popup--active');
            this.backdrop.classList.remove('backdrop--isActive');
            document.body.classList.remove('icore-eventsbyrsquare-popup--is-active');
            if ( !window.$iCore.lenis ) {
                window.$iCore.actions.initializeLenis();
            }
        }
    }

    #fetchElements() {
        this.wrap = document.getElementById('icore-eventsbyrsquare-modal-wrap');
        if ( this.wrap ) {
            this.modal = this.wrap.querySelector('.icore-eventsbyrsquare-popup-modal');
            this.closeButton = this.wrap.querySelector('.icore-eventsbyrsquare-popup-modal__close-btn');
            this.backdrop = this.wrap.querySelector('.icore-eventsbyrsquare-popup-modal__backdrop');

            if ( this.modal ) {
                const wpcf7FormEl = this.modal.querySelector('.wpcf7');
                if ( wpcf7FormEl ) {
                    this.contactFormId = parseInt(wpcf7FormEl.getAttribute('data-wpcf7-id'), 10);
                }
            }

            this.thankYouModal = new ThankYouModal(document.getElementById('icore-eventsbyrsquare-vendor-ty-modal-wrap'));

            this.#setupEventListeners();
        }
    }

    #setupEventListeners() {
        if ( this.closeButton ) {
            this.closeButton.addEventListener('click', this.hide.bind(this));
        }

        const triggers = document.querySelectorAll('.icore-eventsbyrsquare-vendor-partnership-form-trigger');
        if ( triggers.length ) {
            triggers.forEach( trigger => {
                trigger.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.show();
                });
            });
        }

        document.addEventListener('wpcf7mailsent', (event) => {
            if ( event.detail.contactFormId == this.contactFormId ) {
                this.hide();
                if ( this.thankYouModal ) {
                    this.thankYouModal.show();
                }
            }
        }, false);
    }
}

export default VendorPartnershipModal;